<ng-container *cftI18n="let t">
  @if ({loading: loading$ | async}; as ctx) {
    @if (multiSelect) {
      <select
        multiple
        [attr.id]="controlId"
        [class.disabled-text]="!control?.value"
        class="form-select h-full!"
        [class.invalid]="isControlInvalid(control)"
        [formControl]="control | bgoAsFormControl"
        [attr.data-testid]="'select-' + controlId"
        [class.loading]="ctx.loading"
      >
        <option [disabled]="true" [value]="null">
          {{ label ?? t('dropDownNotSelectedMultipleOption') }}
        </option>
        @for (item of items; track item) {
          <option [ngValue]="item.key" (mousedown)="selectMultiple($event, item.key)">
            {{ item.value || (item.valueTranslationKey ? t(item.valueTranslationKey, {key: item.key}) : '') }}
          </option>
        }
      </select>
    } @else {
      <select
        [attr.id]="controlId"
        [class.disabled-text]="!control?.value"
        class="form-select h-full!"
        [class.invalid]="isControlInvalid(control)"
        [formControl]="control | bgoAsFormControl"
        [attr.data-testid]="'select-' + controlId"
        [class.loading]="ctx.loading"
      >
        <option [disabled]="true" [value]="null">
          {{ label ?? t('dropDownNotSelectedOption') }}
        </option>
        @for (item of items; track item) {
          <option [ngValue]="item.key">
            {{ item.value || (item.valueTranslationKey ? t(item.valueTranslationKey, {key: item.key}) : '') }}
          </option>
        }
      </select>
    }

    @if (ctx.loading) {
      <div class="absolute top-0 right-0 bottom-0 pr-md">
        <div class="flex h-full items-center">
          <cft-spinner></cft-spinner>
        </div>
      </div>
    }
  }
</ng-container>
